export enum EditorMode {
  NetzgrafikEditing,
  TopologyEditing,
  StreckengrafikEditing,
  MultiNodeMoving,
  NoteEditing,
  Analytics,
  OriginDestination,
}
